//#region components/select_menu/select_menu_validators.js
var e = (e) => typeof e.value == "string" || typeof e.value == "number", t = (e) => e.label ? typeof e.label == "string" : !1, n = (n) => n ? n.every((n) => !(!e(n) || !t(n))) : !0;
//#endregion
export { n as optionsValidator };

//# sourceMappingURL=select-menu-validators.js.map